// GroupQr.js
import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';
import axios from 'axios';

// Connect to the backend (adjust the URL/port as necessary)
const socket = io('http://localhost:3001');

function GroupQr() {
  const [qrUrl, setQrUrl] = useState('');
  const [isReady, setIsReady] = useState(false);
  const [groupId, setGroupId] = useState('');
  const [saveStatus, setSaveStatus] = useState('');

  useEffect(() => {
    // Listen for the 'qr' event to get the QR code image URL
    socket.on('qr', (data) => {
      setQrUrl(data);
    });
    // Listen for a 'ready' event
    socket.on('ready', (message) => {
      setIsReady(true);
    });
    // Cleanup on unmount
    return () => {
      socket.off('qr');
      socket.off('ready');
    };
  }, []);

  // Function to call the backend to save the group ID
  const saveGroupId = async () => {
    try {
      const response = await axios.post('http://localhost:3001/save-group', { groupId });
      setSaveStatus(response.data.message);
    } catch (error) {
      setSaveStatus('Error saving group id: ' + error.message);
    }
  };

  return (
    <div>
      <h2>WhatsApp Bot QR Code</h2>
      {qrUrl ? (
        <div>
          <img src={qrUrl} alt="QR Code" style={{ width: '300px' }} />
          <p>Scan this QR code with your WhatsApp mobile app to authenticate the bot.</p>
        </div>
      ) : (
        <p>Waiting for QR code...</p>
      )}
      {isReady && <p>WhatsApp Client is ready!</p>}
      
      <h3>Save WhatsApp Group ID</h3>
      <input
        type="text"
        placeholder="Enter Group ID (e.g., 1234567890-123456@g.us)"
        value={groupId}
        onChange={(e) => setGroupId(e.target.value)}
      />
      <button onClick={saveGroupId}>Save Group ID</button>
      {saveStatus && <p>{saveStatus}</p>}
    </div>
  );
}

export default GroupQr;
